import { render } from "./ProductoraList.vue?vue&type=template&id=9ebe9e9e&scoped=true"
import script from "./ProductoraList.vue?vue&type=script&lang=js"
export * from "./ProductoraList.vue?vue&type=script&lang=js"

import "./ProductoraList.vue?vue&type=style&index=0&id=9ebe9e9e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ebe9e9e"]])

export default __exports__